import React from 'react';
import '../styles/experience.css';
import '../styles/sections.css';

const Experience = () => (
  <div className="experience-section">
    <div className="experience-header-row">
      <div className="section-header">
        <h2>EXPERIENCE</h2>
        <div className="underline"></div>
      </div>
      <a href="/resume.pdf" download="Karsten_Hedrick_Resume.pdf" className="resume-download-btn">
        Download Resume
      </a>
    </div>
    <div className="experience-entry">
      <h3>Software Developer – Emerge Consulting (2025–Present)</h3>
      <p style={{ marginBottom: '1rem', color: '#ffffff' }}>Emerge Consulting, Peoria, AZ</p>
      <p style={{ marginBottom: '1rem', color: '#ffffff' }}>Consulting firm developing cross-platform, cloud-deployed software solutions.</p>
      <ul>
        <li>Developed "Climb or Die!" — a multiplayer Roblox game where players navigate challenging obstacles, avoid deadly traps, and compete against time. Built with Roblox Studio and Lua scripting, implementing dynamic difficulty scaling, multiple game modes, power-ups, and comprehensive leaderboard systems using object-oriented design, event-driven programming, and modular service patterns.</li>
        <li>Designed and balanced monetization systems for "Climb or Die!", implementing in-game currency and Robux transactions for power-ups, upgrades, and cosmetic items to enhance player engagement and revenue.</li>
        <li>Developed "Swipe", a social media iOS application with React Native and Expo frontend, tested via Apple TestFlight. Built a scalable Go backend deployed on AWS Lambda and API Gateway, integrated PostgreSQL database on Neon platform, implemented AWS Rekognition for automated image content moderation, and utilized IPFS Pinata for decentralized image storage. Focused on authentication systems, post feeds, and scalable API integration.</li>
      </ul>
    </div>
    <div className="experience-entry">
      <h3>IT Support Specialist – Grand Canyon Education (2023–2024)</h3>
      <ul>
        <li>Utilized Cisco Jabber for team communication and managed support tickets efficiently.</li>
        <li>Leveraged Microsoft Azure for user management within the GCU/GCE domain.</li>
        <li>Collaborated via Microsoft Teams for troubleshooting assistance.</li>
        <li>Handled incoming calls from faculty, providing timely support for computer-related issues.</li>
        <li>Remoted into computers to resolve issues such as broken headsets and login problems.</li>
        <li>Maintained a customer-centric approach to ensure a positive experience for faculty and staff.</li>
      </ul>
    </div>
    <div className="experience-entry">
      <h3>Seasonal Sales Associate – Tillys (2022)</h3>
      <ul>
        <li>Achieved top sales rankings while fostering a positive, passionate atmosphere on the sales floor.</li>
        <li>Enhanced customer service skills to ensure a helpful shopping experience.</li>
        <li>Ranked among top sellers, contributing to team sales goals and customer satisfaction.</li>
        <li>Managed and packaged online orders efficiently as part of a collaborative team.</li>
      </ul>
    </div>
  </div>
);

export default Experience;